import { gql, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { mensajeErrorFiscal } from "services/facturacionErrores";
import {
  Autocomplete,
  Card,
  CircularProgress,
  createFilterOptions,
  Divider,
  Fade,
  Grid,
  Icon,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Tooltip,
} from "@mui/material";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftInputNumber from "components/SoftInputNumberUpgrade";
import SoftTypography from "components/SoftTypography";
import PropTypes from "prop-types";
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { truncar } from "utils/formatters";
import { valorAPesos } from "utils/formatters";
import { validateCUIL } from "utils/validations";
import dataPagos from "../data/dataPagos";
import DataTable from "components/DataTable";
import SinDatos from "components/Carteles/SinDatos";
import { MessageManager } from "context";
import dayjs from "dayjs";
// import { printFactura } from "utils/comanda";
import { SEARCH_UNIFIED_USERS, selectUsersBySource } from "services/unifiedUsers";
import { printComanda } from "utils/comanda";
import { UserContext } from "context/user";
import {
  detalleEsImprimible,
  detallePerteneceASeccion,
  obtenerSeccionesInvolucradas,
} from "utils/seccionesComanda";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "95%",
  width: { xs: "95%", sm: "60%", xxl: "60%" },
  overflowY: "auto",
  p: 3,
};

const facturaInicial = {
  cliente: "Consumidor final",
  tipoFactura: "B",
  nro_doc: "",
  bandejas: 1,
};
const tiposComprobantes = {
  A: 1,
  B: 6,
  C: 11,
};
const clienteInicial = {
  dni: "",
  nombre: "",
  apellido: "",
};

const ModalFacturar = ({ open, handleClose, total, cerrarVenta, pedido }) => {
  const { handleSnackbar } = useContext(MessageManager);

  const [factura, setFactura] = useState(facturaInicial);
  const [cliente, setCliente] = useState(clienteInicial);
  const [tipoClientes, setTipoClientes] = useState("Comedor");
  const [clientes, setClientes] = useState([]);
  const [search, setSearch] = useState("");
  const [debouncing, setDebouncing] = useState(false);
  const [loadingPrint, setLoadingPrint] = useState(false);

  const [pagos, setPagos] = useState([]);
  const [rows, setRows] = useState([]);
  const { columns, getRows } = dataPagos;
  const [medioDePago, setMedioDePago] = useState({
    nombre: "",
    totalPago: 0,
    recargo: 0,
    cuotas: 1,
    alias: "",
    cbu: "",
    titular: "",
  });
  const { user } = useContext(UserContext);
  const recargoPago = truncar(medioDePago.totalPago * (medioDePago.recargo / 100)) || 0;
  const totalPagos = useMemo(() => pagos.reduce((acc, pago) => acc + pago.totalPago, 0), [pagos]);
  const totalRecargo = useMemo(
    () => pagos.reduce((acc, pago) => acc + pago.totalRecargo, 0),
    [pagos]
  );
  const descuento = pagos
    .filter((pago) => pago.nombre === "Descuento")
    .reduce((acc, pago) => acc + pago.totalPago, 0);
  const restanteAPagar = total - totalPagos;
  const calculoTotalFinal = totalPagos + totalRecargo - descuento;
  const totalFinal = truncar(calculoTotalFinal) || 0;

  useEffect(() => {
    setMedioDePago((prev) => ({
      ...prev,
      totalPago: restanteAPagar,
    }));
  }, [restanteAPagar]);

  const { data } = useQuery(
    gql`
      query getMediosPago($filter: JSON) {
        mediosDePago(filter: $filter) {
          id
          nombre
          cuotas
          recargo
          favorito
          titular
          alias
          cbu
        }
      }
    `,
    {
      fetchPolicy: "network-only",
      nextFetchPolicy: "cache-first",
      onCompleted: (data) => {
        const medioDePagoFavorito = data?.mediosDePago.filter((medio) => medio.favorito);
        if (medioDePagoFavorito.length > 0) {
          setMedioDePago({
            ...medioDePagoFavorito[0],
            totalPago: restanteAPagar,
            id: medioDePagoFavorito[0].id,
          });
        }
      },
    }
  );
  const handleChangeFactura = (e) => {
    if (e.target.name === "bandejas") {
      if (e.target.value < 0) {
        setFactura({
          ...factura,
          [e.target.name]: 0,
        });
        return;
      }
    }
    setFactura({
      ...factura,
      [e.target.name]: e.target.value,
    });
  };
  const handleChangeFormaDePago = (e) => {
    if (e.target.name === "nombre") {
      const selectedId = e.target.value;
      const selectedMedio = data?.mediosDePago.find((medio) => medio.id === selectedId) || {
        nombre: e.target.value === "Cuenta corriente" ? "Cuenta corriente" : "Descuento",
        recargo: 0,
        cuotas: 1,
        id: e.target.value === "Cuenta corriente" ? "Cuenta corriente" : 0,
        alias: "",
        cbu: "",
        titular: "",
      };
      setMedioDePago((prev) => ({
        ...prev,
        nombre: selectedMedio?.nombre,
        recargo: selectedMedio?.recargo,
        cuotas: selectedMedio?.cuotas,
        alias: selectedMedio?.alias,
        cbu: selectedMedio?.cbu,
        titular: selectedMedio?.titular,
        id: selectedMedio?.id,
      }));
    } else {
      setMedioDePago({
        ...medioDePago,
        [e.target.name]: e.target.value,
      });
    }
  };
  const validarCuit = () => {
    if (factura.tipoFactura === "A") {
      return validateCUIL(factura.nro_doc || "");
    }
    if (factura.tipoFactura === "C") {
      return (
        factura.nro_doc.length === 8 || factura.nro_doc.length === 7 || factura.nro_doc.length === 0
      );
    }
    if (factura.tipoFactura === "V" && tipoClientes === "Particular") {
      return factura.nro_doc.length === 8 || factura.nro_doc.length === 7;
    }
    if (!factura.tipoFactura) {
      return false;
    }
    return true;
  };
  useEffect(() => {
    setRows(getRows(pagos, ejecutarAccion));
  }, [pagos]);

  //Facturar
  const [saveVenta, { loading: loadingSave }] = useMutation(
    gql`
      mutation saveVenta($input: VentaInput!) {
        saveVenta(input: $input) {
          id
          pedido {
            detalles {
              numeroComanda
              producto {
                id
                esElaborado
              }
            }
          }
        }
      }
    `
  );
  const handleSave = () => {
    const detalles = pedido?.detalles?.map((detalle) => ({
      idProducto: detalle.producto.id,
      comentario: detalle.comentario,
      cantidad: Number(detalle.cantidad),
      precio: detalle.precio,
      idsIngredientesQuitados: detalle.ingredientesQuitados?.map((ingrediente) => ingrediente.id),
      estado: "PENDIENTE",
      horarioEntrega: detalle.horarioEntrega,
      esElaborado: detalle.esElaborado,
    }));

    let tipo_cbte = tiposComprobantes[factura.tipoFactura];
    let subtotal21 = truncar(totalFinal / 1.21);
    let nro_doc = factura.nro_doc || "0";
    let tipo_doc = factura.tipoDeVenta === "C" ? 80 : factura?.nro_doc.length === 11 ? 80 : 99;
    let cuentaCorriente = pagos.some((pago) => pago.nombre === "Cuenta corriente");
    saveVenta({
      variables: {
        input: {
          idMozo: user.id,
          nombre: cliente.nombre || "",
          apellido: cliente.apellido || "",
          cliente: (cliente.nombre || "") + " " + (cliente.apellido || ""),
          tipoFactura: factura.tipoFactura,
          tipo_cbte: tipo_cbte,
          tipo_doc: tipo_doc,
          nro_doc: nro_doc,
          subtotal21: subtotal21,
          imp_iva21: 0,
          concepto: 1,
          nroAnulado: 0,
          total: totalFinal,
          fecha: dayjs().format("YYYY-MM-DD"),
          cuitEmpresa: null,
          pto_vta: 3,
          pagos: !cuentaCorriente ? pagos : [],
          descuento: descuento,
          recargo: totalRecargo,
          mesa: null,
          appUsuario: tipoClientes,
          idUsuario: cliente.id,
          tipoUsuario: cliente.tipoUser,
          detalles: detalles,
          cuentaCorriente: cuentaCorriente,
          bandejas: factura.bandejas ? parseInt(factura.bandejas) : 1,
          estado: "EN PREPARACIÓN",
        },
      },
    })
      .then((res) => {
        // printFactura(data.data.saveVenta, user.empresa);
        // Separar los items por sección
        const detallesImprimibles = (pedido?.detalles || []).filter(detalleEsImprimible);
        const secciones = obtenerSeccionesInvolucradas(detallesImprimibles);
        const detallesPorSeccion = secciones.map((seccion) => {
          return {
            seccion: seccion,
            detalles: detallesImprimibles
              .filter((detalle) => detallePerteneceASeccion(detalle, seccion))
              .map((detalle) => {
                return {
                  ...detalle,
                  nroComanda: res.data.saveVenta.pedido?.detalles?.find(
                    (d) => d.producto.id === detalle.producto.id
                  ).numeroComanda,
                };
              }),
          };
        });
        // Enviar a imprimir la comanda por seccion
        setLoadingPrint(true);
        detallesPorSeccion.forEach(async (seccion) => {
          await printComanda(seccion.detalles, seccion.seccion).then((response) => {
            if (response?.status !== 200) {
              handleSnackbar(
                `Error al imprimir comanda de ${seccion.seccion} ${
                  response?.data?.message ? `: ${response?.data?.message}` : ""
                }`,
                "error"
              );
            }
          });
        });
        setLoadingPrint(false);
        handleSnackbar("Finalizado correctamente", "success");
        handleClose();
        cerrarVenta();
      })
      .catch((error) => {
        handleSnackbar(mensajeErrorFiscal(error), "error");
      });
  };

  const ejecutarAccion = (accion, item) => {
    switch (accion) {
      case "borrar":
        setPagos((prev) =>
          prev.filter(
            (pago) =>
              !(
                pago.totalPago === item.totalPago &&
                pago.nombre === item.nombre &&
                pago.cuotas === item.cuotas
              )
          )
        );
        break;
      default:
        break;
    }
  };

  const cerrarModal = () => {
    if (loadingSave) return;
    let medioPagoFavorito = data?.mediosDePago.find((medio) => medio.favorito);
    if (medioPagoFavorito) {
      setMedioDePago({
        ...medioPagoFavorito,
        totalPago: restanteAPagar,
      });
    } else {
      setMedioDePago({
        nombre: "",
        totalPago: 0,
        recargo: 0,
        cuotas: 1,
        alias: "",
        cbu: "",
        titular: "",
      });
    }
    setFactura(facturaInicial);
    setPagos([]);
    setSearch("");
    handleClose();
  };
  const filterOptions = createFilterOptions({
    stringify: ({ apellido, nombre, dni }) => `${apellido} ${nombre} ${dni}`,
    limit: 15,
  });

  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  };
  const [getUnifiedUsers] = useLazyQuery(SEARCH_UNIFIED_USERS, {
    fetchPolicy: "network-only",
  });

  const handleChangeTipo = (e) => {
    setTipoClientes(e.target.value);
    setCliente(clienteInicial);
    setClientes([]);
    if (e.target.value !== "Particular") {
      setFactura({
        ...factura,
        tipoFactura: "B",
      });
    }
  };
  const handleSearchDebounce = useCallback(
    debounce(async (searchTerm, source) => {
      try {
        const { data: result } = await getUnifiedUsers({
          variables: { searchTerm },
        });
        setClientes(selectUsersBySource(result?.searchUnifiedUsers, source));
      } finally {
        setDebouncing(false);
      }
    }, 1000),
    [getUnifiedUsers]
  );

  useEffect(() => {
    if (open) {
      const source = tipoClientes === "Alumno" ? "Alumnos" : tipoClientes === "Comedor" ? "Comedor" : "Compras";
      handleSearchDebounce(search, source);
    }
  }, [search, open, tipoClientes, handleSearchDebounce]);

  const handleSearchChange = (e, value) => {
    if (value.length > 1) {
      setDebouncing(true);
    }
    setSearch(value);
  };
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      disableEscapeKeyDown={loadingSave ? true : false}
      onClose={cerrarModal}
    >
      <Fade in={open}>
        <Card sx={style}>
          <Grid container spacing={1} display="flex" justifyContent="flex-end">
            <Grid item xs={12} display="flex" justifyContent="space-between">
              <Grid display="flex" flexDirection="row">
                <SoftTypography fontWeight="bold">Total: {valorAPesos(total)}</SoftTypography>
              </Grid>
              <Grid>
                <Tooltip title="Cerrar" placement="top">
                  <Icon fontSize="medium" onClick={cerrarModal} sx={{ cursor: "pointer" }}>
                    close
                  </Icon>
                </Tooltip>
              </Grid>
            </Grid>
            <Grid item xs={4} sm={4}>
              <InputLabel htmlFor="nombre">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Tipo de usuario
                  <SoftTypography variant="caption" fontWeight="bold" color="primary">
                    &nbsp;*
                  </SoftTypography>
                </SoftTypography>
              </InputLabel>
              <Select name="tipo" value={tipoClientes} onChange={handleChangeTipo}>
                {/* <MenuItem value={"Comedor"}>Comedor</MenuItem> */}
                {/* <MenuItem value={"Alumno"}>Alumno</MenuItem> */}
                <MenuItem value={"Compras"}>Sistema UPrO</MenuItem>
                <MenuItem value={"Particular"}>Particular</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={6}>
              <InputLabel htmlFor="cliente">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Buscar por Nombre / DNI
                </SoftTypography>
              </InputLabel>
              <Autocomplete
                disabled={tipoClientes === "Particular"}
                clearOnEscape
                options={!debouncing ? clientes : []}
                value={cliente ? cliente : null}
                loading={debouncing}
                loadingText="Buscando..."
                noOptionsText={
                  search.length > 1 ? "No se encontraron resultados" : "Escriba para buscar"
                }
                onInputChange={handleSearchChange}
                getOptionLabel={(option) =>
                  option?.nombre
                    ? option.nombre +
                      " " +
                      option.apellido +
                      (option.dni ? " - Dni:" + option.dni : "")
                    : ""
                }
                filterOptions={(options, params) => {
                  const filtered = filterOptions(options, params);
                  return filtered;
                }}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setCliente(newValue);
                    setFactura((prev) => ({
                      ...prev,
                      nro_doc: newValue.dni || "",
                    }));
                  } else {
                    setCliente(clienteInicial);
                  }
                }}
                renderInput={(params) => {
                  return (
                    <TextField
                      {...params}
                      slotprops={{
                        input: {
                          ...params.InputProps,
                          type: "search",
                        },
                      }}
                    />
                  );
                }}
              />
            </Grid>
            <Grid item xs={2} sm={2}>
              <InputLabel htmlFor="bandejas">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Bandejas
                </SoftTypography>
              </InputLabel>
              <SoftInput
                placeholder="Bandejas"
                name="bandejas"
                type="number"
                value={factura?.bandejas}
                onChange={handleChangeFactura}
                step={1}
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </Grid>
            {/* {tipoClientes === "Particular" && (
              <>
                <Grid item xs={4}>
                  <InputLabel htmlFor="handleChangeFactura">
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                      Tipo de factura
                    </SoftTypography>
                  </InputLabel>
                  <Select
                    name="tipoFactura"
                    value={factura?.tipoFactura}
                    onChange={handleChangeFactura}
                  >
                    {TIPO_FACTURAS.map((tipo) => (
                      <MenuItem key={tipo.value} value={tipo.value}>
                        {tipo.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
              </>
            )} */}
            <Grid item xs={tipoClientes !== "Particular" ? 12 : 12}>
              <InputLabel htmlFor="nro_doc">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Cuit/DNI
                </SoftTypography>
              </InputLabel>
              <SoftInput
                placeholder="Cuit/DNI"
                name="nro_doc"
                value={factura?.nro_doc}
                onChange={handleChangeFactura}
                error={!validarCuit()}
                success={validarCuit()}
              />
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <InputLabel htmlFor="condicionIva">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Medio de pago
                </SoftTypography>
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  color="primary"
                >
                  {" "}
                  {medioDePago.alias && "- Alias: " + medioDePago.alias}{" "}
                  {medioDePago.cbu && "- CBU: " + medioDePago.cbu}
                </SoftTypography>
              </InputLabel>
              <Select name="nombre" value={medioDePago?.id} onChange={handleChangeFormaDePago}>
                {data?.mediosDePago.map((medio) => (
                  <MenuItem key={medio.id} value={medio.id}>
                    {medio.nombre + " - " + medio.cuotas + " cuotas"} -{" "}
                    {"Recargo: " + medio.recargo + "%"} - {medio.titular ? medio.titular : ""}
                  </MenuItem>
                ))}
                {/* <MenuItem value={0}>Descuento</MenuItem> */}
                {tipoClientes !== "Particular" && (
                  <MenuItem disabled={pagos.length > 0} value={"Cuenta corriente"}>
                    Cuenta corriente
                  </MenuItem>
                )}
              </Select>
            </Grid>
            <Grid item xs={10}>
              <InputLabel htmlFor="Total">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  {medioDePago.id === 0 ? "Descuento $" : "Total a pagar"}
                </SoftTypography>
                <SoftTypography component="label" variant="caption" color="primary">
                  {medioDePago.id !== 0 && ` (Recargo: $${recargoPago})`}
                </SoftTypography>
              </InputLabel>
              <SoftInputNumber
                placeholder="$"
                name="totalPago"
                value={medioDePago.totalPago}
                onChange={handleChangeFormaDePago}
                disabled={medioDePago.id === "Cuenta corriente"}
              />
            </Grid>
            <Grid item xs={2} display="flex" justifyContent="flex-end" alignItems="flex-end">
              <SoftButton
                fullWidth
                color="primary"
                onClick={() => {
                  setPagos((prev) => [
                    ...prev,
                    {
                      nombre: medioDePago.nombre,
                      cuotas: medioDePago.cuotas,
                      totalPago: medioDePago.totalPago,
                      recargo: recargoPago,
                      totalRecargo: recargoPago,
                      idMedioDePago: medioDePago.id,
                    },
                  ]);
                }}
                disabled={medioDePago.totalPago <= 0 || !medioDePago.nombre}
              >
                +
              </SoftButton>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                maxHeight: "250px",
                overflowY: "auto",
              }}
            >
              {pagos.length > 0 ? (
                <DataTable columns={columns} rows={rows} />
              ) : (
                <SinDatos
                  titulo="No hay pagos"
                  mensaje="Cargue un pago para finalizar"
                  icono="payments"
                />
              )}
            </Grid>
          </Grid>
          <Grid mt={2}>
            <SoftTypography variant="subtitle2" color={restanteAPagar < 0 ? "error" : "inherit"}>
              Restante: {valorAPesos(restanteAPagar)}
            </SoftTypography>
            <SoftTypography variant="subtitle2" fontWeight="bold">
              Total: {valorAPesos(totalFinal)}
            </SoftTypography>
          </Grid>
          <Grid
            display={{
              xs: "flex-row",
              sm: "flex",
            }}
            justifyContent="flex-end"
            alignItems="center"
          >
            <Grid
              mr={{
                xs: 0,
                sm: 2,
              }}
              mt={{
                xs: 2,
                sm: 0,
              }}
            >
              <SoftButton
                color="primary"
                circular
                onClick={cerrarModal}
                fullWidth={{
                  xs: true,
                  sm: false,
                }}
                disabled={loadingSave || loadingPrint}
              >
                <Icon sx={{ fontWeight: "light" }}>cancel</Icon>
                &nbsp;Cancelar
              </SoftButton>
            </Grid>
            <Grid
              mt={{
                xs: 2,
                sm: 0,
              }}
            >
              <SoftButton
                color="uproGreen"
                circular
                fullWidth={{
                  xs: true,
                  sm: false,
                }}
                onClick={handleSave}
                disabled={
                  pagos.length === 0 ||
                  loadingSave ||
                  loadingPrint ||
                  !validarCuit() ||
                  restanteAPagar !== 0
                }
              >
                {loadingSave || loadingPrint ? (
                  <CircularProgress size={15} color="inherit" />
                ) : (
                  <Icon sx={{ fontWeight: "light" }}>attach_money</Icon>
                )}
                &nbsp;Finalizar
              </SoftButton>
            </Grid>
          </Grid>
        </Card>
      </Fade>
    </Modal>
  );
};

export default ModalFacturar;

ModalFacturar.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  total: PropTypes.number,
  cerrarVenta: PropTypes.func,
  pedido: PropTypes.object,
};
